// @flow
import * as React from 'react';
import SidePane from 'esm-web-pro/components/layout/SidePane';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closePanel as closePanelAction } from 'esm-web-pro/redux/side-panel/actions';
import { MapContext } from 'esm-web-pro/containers/map/context';
import ConnectPortsToPorts from './poplayer12/ConnectPortsToPorts';
import ConnectFibersODFPorts from './poplayer12/ConnectFibersODFPorts';
import SpliceFiberForm from './SpliceFiberForm';


export const CONNECT_FIBER_KEY = 'CONNECT_FIBER';

type SidePanelActionProps = {
    closePanel: (key: string, skipSensitivity?: boolean) => { key: string },
}

type Props = {
    ...$Exact<SidePanelActionProps>,
    connecting: {
        cable: Object,
        fiberSequence: number,
    } | { portToFiber: Object } | { portToPort: Object },
    onSave: Function,
    opticalPorts: ?Object,
    // opticalSwitchPorts: Object[],
};

const formTitle = (connecting: Object) => {
    if (connecting.portToFiber) {
        return (
            <FormattedMessage
                id="connect-fiber-to-port-title"
                defaultMessage="Connect fiber to port {ref}"
                values={{ ref: connecting.portToFiber.ref }}
            />
        );
    }

    if (connecting.portToPort) {
        return (
            <FormattedMessage
                id="connect-port-to-port-title"
                defaultMessage="Connect port to port {ref}"
                values={{ ref: connecting.portToPort.ref }}
            />
        );
    }

    if (connecting.cable && connecting.fiberSequence) {
        return (
            <FormattedMessage
                id="splice-fiber-title"
                defaultMessage="Splice fiber K{cableSequence}-F{fiberSequence}"
                values={{ cableSequence: connecting.cable.sequence, fiberSequence: connecting.fiberSequence }}
            />
        );
    }

    return null;
};

const ConnectFiber = (props: Props) => {
    const {
        connecting, onSave, closePanel, opticalPorts, ...rest
    } = props;

    if (!connecting) return null;

    const handleConnect = () => {
        closePanel(CONNECT_FIBER_KEY, true);
        onSave();
    };

    const handleClose = () => {
        closePanel(CONNECT_FIBER_KEY);
    };

    return (
        <SidePane
            id={CONNECT_FIBER_KEY}
            openInitially
            sensitive
            key={CONNECT_FIBER_KEY}
            title={formTitle(connecting)}
        >
            <MapContext.Consumer>
                {(map) => {
                    if (connecting.cable && connecting.fiberSequence) {
                        return (
                            <SpliceFiberForm
                                cable={connecting.cable}
                                fiber={connecting.fiberSequence}
                                onSave={handleConnect}
                                onClose={handleClose}
                                map={map}
                                {...rest}
                            />
                        );
                    }
                    if (connecting.portToFiber) {
                        const { cables, ...restProps } = rest;
                        const allowedCables = cables.filter((c) => c.patch === false);
                        return (
                            <ConnectFibersODFPorts
                                port={connecting.portToFiber}
                                ports={opticalPorts}
                                onSave={handleConnect}
                                onClose={handleClose}
                                map={map}
                                cables={allowedCables}
                                {...restProps}
                            />
                        );
                    }
                    if (connecting.portToPort) {
                        return (
                            <ConnectPortsToPorts
                                port={connecting.portToPort}
                                ports={opticalPorts}
                                onSave={handleConnect}
                                onClose={handleClose}
                                map={map}
                                {...rest}
                            />
                        );
                    }
                    return null;
                }}
            </MapContext.Consumer>
        </SidePane>
    );
};

export default connect(
    null, (dispatch) => (
        bindActionCreators({ closePanel: closePanelAction }, dispatch)
    ),
)(ConnectFiber);
